import * as actionTypes from "Application/Store/Actions/ToothTypes";

/*****************************************************************
 *  Tooth Reducer
 * ***************************************************************/

const initialState = {
    selectedTooth: null,
    teethMovements: {},
    selectedPointRotation: "CentralPit",
    selectedPointTip: "RotationRoot",
    selectedPointTorque: "RotationRoot"
};

/**
 * Update State
 * @param {object} state
 * @param {*} action
 * @returns
 */
export const ToothReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_SELECTED_TOOTH:
            return {
                ...state,
                selectedTooth: action.payload,
            };

        case actionTypes.CLEAR_SELECTED_TOOTH:
            return {
                ...state,
                selectedTooth: null,
            };
        case actionTypes.SET_TOOTH_MOVEMENTS:
            return {
                ...state,
                teethMovements: {
                    ...state.teethMovements,
                    [action.payload.toothId]: action.payload
                }
            };
        case actionTypes.SET_SELECTED_POINT_ROTATION:
            return {
                ...state,
                selectedPointRotation: action.payload
            };
        case actionTypes.SET_SELECTED_POINT_TIP:
            return {
                ...state,
                selectedPointTip: action.payload
            }
        case actionTypes.SET_SELECTED_POINT_TORQUE:
            return {
                ...state,
                selectedPointTorque: action.payload
            }
        case "ADD_MOVEMENT": {
            const { toothId, movementType, value } = action.payload;

            return {
                ...state,
                teethMovements: {
                    ...state.teethMovements,
                    [toothId]: {
                        ...state.teethMovements[toothId], // Garde les autres mouvements
                        [movementType]: value // Ajoute/Met à jour le mouvement
                    }
                }
            };
        }
        case "SET_COLLISION": {
            return {
                ...state,
                isCollisionSystemEnabled: action.payload
            };
        }

        default:
            return state;
    }
};
